export default import.meta.ROLLDOWN_FILE_URL_ExXMsZiHL1iQ$rmVWlXjOg